export default {
  "nav.home": "Strona główna",
  "nav.guide": "Przewodnik zakupowy",
  "nav.browse": "Przeglądaj kategorie",
  "brand.tagline": "Zasób USFans Spreadsheet",
  "brand.subtag": "Niezależny zasób",

  "cta.spreadsheet": "USFans Spreadsheet",
  "cta.buyNow": "Kup teraz",
  "cta.explore": "Odkryj USFans Spreadsheet",
  "cta.browse": "Przeglądaj kategorie",
  "cta.main": "Przejdź do głównej strony",

  "dropdown.label": "Przejdź do kategorii",
  "dropdown.placeholder": "Wybierz kategorię…",

  "category.shoes": "Buty",
  "category.hoodies": "Bluzy/Swetry",
  "category.tshirts": "T-shirty",
  "category.jackets": "Kurtki",
  "category.pants": "Spodnie/Szorty",
  "category.headwear": "Nakrycia głowy",
  "category.sets": "Zestawy",
  "category.underwear": "Bielizna/Majtki",
  "category.jersey": "Koszulki sportowe",
  "category.accessories": "Akcesoria",
  "category.bags": "Torby",
  "category.belts": "Paski",
  "category.perfumes": "Perfumy",
  "category.other": "Inne artykuły",

  "categoryDesc.shoes": "Sneakersy, obuwie casual i sportowe.",
  "categoryDesc.hoodies": "Bluzy, rozpinane i ciepłe warstwy.",
  "categoryDesc.tshirts": "Koszulki z krótkim i długim rękawem.",
  "categoryDesc.jackets": "Kurtki na każdą porę roku.",
  "categoryDesc.pants": "Jeansy, chinosy i szorty.",
  "categoryDesc.headwear": "Czapki, kapelusze i czapki zimowe.",
  "categoryDesc.sets": "Pasujące zestawy ubrań.",
  "categoryDesc.underwear": "Bielizna i podstawy garderoby.",
  "categoryDesc.jersey": "Koszulki sportowe i drużynowe.",
  "categoryDesc.accessories": "Zegarki i drobne dodatki.",
  "categoryDesc.bags": "Plecaki, torebki i torby.",
  "categoryDesc.belts": "Paski skórzane i casualowe.",
  "categoryDesc.perfumes": "Perfumy dla kobiet i mężczyzn.",
  "categoryDesc.other": "Różne i nowości.",

  "footer.about": "usfanslink.lol to niezależny zasób informacyjny o USFans Spreadsheet. Nie jesteśmy powiązani z USFans.",
  "footer.disclaimer": "Zastrzeżenie",
  "footer.disclaimerText": "Ta strona jest niezależnym zasobem informacyjnym i niekoniecznie jest powiązana z USFans.",
  "footer.quickLinks": "Szybkie linki",
  "footer.rights": "Wszelkie prawa zastrzeżone.",
};